import { create } from "zustand";

export type SiteAssessmentsTasksState = {
  hasNoData: boolean;
  isLoading: boolean;
};

type SiteAssessmentsTasksActions = {
  setTasksState: (state: Partial<SiteAssessmentsTasksState>) => void;
};

export type SiteAssessmentsTasksStore = SiteAssessmentsTasksState & SiteAssessmentsTasksActions;

const initialState: SiteAssessmentsTasksState = {
  hasNoData: false,
  isLoading: false,
};

export const useSiteAssessmentsTasks = create<SiteAssessmentsTasksStore>(set => ({
  ...initialState,
  //
  setTasksState: newState =>
    set(state => ({
      ...state,
      ...newState,
    })),
}));
